(function () {
  var WIDGET_SEL = '.shopify_subscriptions_app_container';
  var BTN_SEL = '[name="add"], button[type="submit"].product-form__submit, #ProductSubmitButton, .product-form__submit';
  var _timer = null;

  function stripPrice(text) {
    return text.replace(/ \|[^]*$/, '').trim();
  }

  function getWidgetPrice() {
    var widget = document.querySelector(WIDGET_SEL);
    if (!widget) return null;
    var otpRadio = widget.querySelector('.tab_radio[id^="tab_otp_"]');
    if (otpRadio && otpRadio.checked) {
      var otpPrice = widget.querySelector('.price');
      return otpPrice ? otpPrice.textContent.trim() : null;
    }
    var checkedInput = widget.querySelector('.group_list input[type="radio"]:checked');
    if (checkedInput) {
      var label = checkedInput.closest('.group_list_item');
      if (label) {
        var priceEl = label.querySelector('.price');
        if (priceEl) return priceEl.textContent.trim();
      }
    }
    var firstPrice = widget.querySelector('.price');
    return firstPrice ? firstPrice.textContent.trim() : null;
  }

  function syncPrice() {
    var price = getWidgetPrice();
    var btns = document.querySelectorAll(BTN_SEL);
    btns.forEach(function (btn) {
      // Target the span inside the button — never touch .loading__spinner or other child elements
      var span = btn.querySelector('span:not([class])') || btn.querySelector('span');
      var target = span || btn;
      var base = stripPrice(target === btn
        ? (Array.from(btn.childNodes).find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim())?.textContent || 'Add to Cart')
        : target.textContent);
      if (!base) base = 'Add to Cart';
      if (target === btn) {
        // fallback: update first text node only
        var textNode = Array.from(btn.childNodes).find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
        if (textNode) textNode.textContent = price ? base + ' | ' + price : base;
      } else {
        target.textContent = price ? base + ' | ' + price : base;
      }
    });
  }

  function clearUnavailable() {
    document.querySelectorAll('[data-variant-unavailable]').forEach(function (el) {
      el.removeAttribute('data-variant-unavailable');
    });
  }

  function syncPurchaseOption() {
    var widget = document.querySelector(WIDGET_SEL);
    if (!widget) return;
    var otpTabRadio = widget.querySelector('.tab_radio[id^="tab_otp_"]');
    var subTabRadio = widget.querySelector('.tab_radio[id^="tab_subscribe_"]');
    var otpPurchaseRadio = widget.querySelector('input[data-radio-type="one_time_purchase"]');
    var sellingPlanRadios = widget.querySelectorAll('input[data-radio-type="selling_plan"]');

    if (otpTabRadio && otpTabRadio.checked) {
      if (otpPurchaseRadio && !otpPurchaseRadio.checked) {
        otpPurchaseRadio.checked = true;
        otpPurchaseRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (subTabRadio && subTabRadio.checked) {
      var checkedPlan = widget.querySelector('input[data-radio-type="selling_plan"]:checked');
      if (!checkedPlan && sellingPlanRadios.length > 0) {
        sellingPlanRadios[0].checked = true;
        sellingPlanRadios[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    clearUnavailable();
  }


  function syncTabStyles() {
    var widget = document.querySelector(WIDGET_SEL);
    if (!widget) return;
    var otpRadio = widget.querySelector('.tab_radio[id^="tab_otp_"]');
    var subRadio = widget.querySelector('.tab_radio[id^="tab_subscribe_"]');
    var labels = widget.querySelectorAll('.tab_label');
    if (!labels.length) return;

    var otpLabel = labels[0];
    var subLabel = labels[labels.length - 1];

    var otpActive = otpRadio && otpRadio.checked;
    var subActive = subRadio && subRadio.checked;

      // Preserve last known active tab during transient rebuilds where neither radio reads as checked (never fall back to OTP blindly)
      if (!otpActive && !subActive) {
          otpActive = widget.dataset.uaActiveTab !== 'sub';
      } else {
          widget.dataset.uaActiveTab = otpActive ? 'otp' : 'sub';
      }

    if (otpActive) {
      otpLabel.classList.add('ua-tab-active');
      otpLabel.classList.remove('ua-tab-inactive');
      subLabel.classList.add('ua-tab-inactive');
      subLabel.classList.remove('ua-tab-active');
    } else {
      subLabel.classList.add('ua-tab-active');
      subLabel.classList.remove('ua-tab-inactive');
      otpLabel.classList.add('ua-tab-inactive');
      otpLabel.classList.remove('ua-tab-active');
    }
  }

  function debouncedSync() {
    clearTimeout(_timer);
    _timer = setTimeout(function () {
      syncPurchaseOption();
      syncPrice();
      syncTabStyles();
    }, 80);
  }
  function autoSelectSubscription() {
    var widget = document.querySelector(WIDGET_SEL);
    if (!widget) return;
    setTimeout(function() {
      var subRadio = widget.querySelector('.tab_radio[id^="tab_subscribe_"]');
      if (subRadio && !subRadio.checked) {
        subRadio.checked = true;
        subRadio.dispatchEvent(new Event('change', {bubbles:true}));
        subRadio.dispatchEvent(new Event('click', {bubbles:true}));
      }
      var firstFreq = widget.querySelector('.group_list_item.custom_radio_button input');
      if (firstFreq && !firstFreq.checked) {
        firstFreq.checked = true;
        firstFreq.dispatchEvent(new Event('change', {bubbles:true}));
      }
      syncTabStyles();
      syncPurchaseOption();
      syncPrice();
    }, 400);
  }
  function init() {
    var widget = document.querySelector(WIDGET_SEL);
    if (!widget) return;

    clearUnavailable();
    syncPurchaseOption();
    debouncedSync();
    syncTabStyles();
        autoSelectSubscription();

    document.addEventListener('change', debouncedSync, true);
    document.addEventListener('click', debouncedSync, true);

    var observer = new MutationObserver(function (mutations) {
      var needsClear = mutations.some(function (m) {
        return m.type === 'attributes' && m.attributeName === 'data-variant-unavailable';
      });
      if (needsClear) clearUnavailable();
      debouncedSync();
    });

    observer.observe(widget, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-variant-unavailable'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();